import React, { useState } from 'react'
// import material ui
import {
    makeStyles,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    Hidden,
    Typography,
    IconButton,
} from '@material-ui/core';
// import i18n
import { useTranslation } from 'react-i18next';
// import fetch
import axInst from '../../../_helpers/axios-instance';
// import moment
import moment from 'moment';

const useStyles = makeStyles(theme => ({
    root: {
        position: 'relative',
        width: "100%",
        maxWidth: "500px",
        margin: "0 auto",
        textAlign: "center",

        "& h1": {
            fontSize: 16,
            fontWeight: 700,
            color: "#555F7E",
            padding: "4px 0 16px 0",
        },

        "& img": {
            width: 209,
            height: 133,
            objectFit: "contain",
            objectPosition: "center",
            margin: "38px 0",
        },

        "& button": {
            width: 164,
            margin: "0 auto",
            fontWeight: 700,
        },
    },

    price: {
        fontSize: 16,
        fontWeight: 700,
        color: "#279F51",
    },
}));

const PopupAddBonusItem = (props) => {
    const { data, onClose, customer_id, getBonusBalance } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    const [disabled, setDisabled] = useState(false);

    const onClick = () => {
        setDisabled(true);
        axInst.post("/api/create-bonus-order/", {
            customer_id: customer_id,
            product_id: data?.id,
        }).then(response => {
            getBonusBalance(customer_id, moment(moment().subtract(1, 'month')).format('DD.MM.YYYY'), moment(new Date()).format('DD.MM.YYYY'));
            onClose();
        }).catch(err => {
            console.log(err.message || "Виникла невідома помилка");
        });
        setDisabled(false);
    }

    return (
        <Dialog
            className="dialog-wrapper"
            onClose={onClose}
            maxWidth="xl"
            fullWidth={true}
            open={data.id !== undefined ? true : false}>
            <DialogTitle style={{
                margin: 0,
                flex: "0 0 auto",
                padding: 32,
            }}>
                <Grid style={{ alignItems: "flex-start" }} container>
                    <Grid container item xs={2} align="left">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M27 9.50005H20.8512C21.4242 9.24682 21.9562 8.9098 22.43 8.50005C22.7585 8.2079 23.0232 7.85103 23.2073 7.4518C23.3914 7.05257 23.4911 6.6196 23.5 6.18005C23.5142 5.69294 23.4287 5.20807 23.2487 4.75518C23.0688 4.3023 22.7983 3.89095 22.4537 3.54636C22.1091 3.20178 21.6978 2.93122 21.2449 2.7513C20.792 2.57138 20.3071 2.48588 19.82 2.50005C19.3804 2.50897 18.9475 2.60862 18.5483 2.79275C18.149 2.97688 17.7921 3.24151 17.5 3.57005C16.7613 4.4038 16.2962 5.49005 16 6.5313C15.7063 5.49005 15.2412 4.4063 14.5 3.57005C14.2079 3.24151 13.851 2.97688 13.4517 2.79275C13.0525 2.60862 12.6196 2.50897 12.18 2.50005C11.6929 2.48588 11.208 2.57138 10.7551 2.7513C10.3022 2.93122 9.8909 3.20178 9.54631 3.54636C9.20173 3.89095 8.93118 4.3023 8.75125 4.75518C8.57133 5.20807 8.48583 5.69294 8.5 6.18005C8.50892 6.6196 8.60857 7.05257 8.7927 7.4518C8.97683 7.85103 9.24146 8.2079 9.57 8.50005C10.0438 8.9098 10.5758 9.24682 11.1488 9.50005H5C4.60218 9.50005 4.22064 9.65808 3.93934 9.93939C3.65804 10.2207 3.5 10.6022 3.5 11V15C3.5 15.3979 3.65804 15.7794 3.93934 16.0607C4.22064 16.342 4.60218 16.5 5 16.5H5.5V25C5.5 25.3979 5.65804 25.7794 5.93934 26.0607C6.22064 26.342 6.60218 26.5 7 26.5H25C25.3978 26.5 25.7794 26.342 26.0607 26.0607C26.342 25.7794 26.5 25.3979 26.5 25V16.5H27C27.3978 16.5 27.7794 16.342 28.0607 16.0607C28.342 15.7794 28.5 15.3979 28.5 15V11C28.5 10.6022 28.342 10.2207 28.0607 9.93939C27.7794 9.65808 27.3978 9.50005 27 9.50005ZM18.25 4.23255C18.4519 4.00686 18.6982 3.8253 18.9735 3.69925C19.2489 3.57321 19.5472 3.50539 19.85 3.50005H19.9263C20.2706 3.50041 20.6114 3.56978 20.9285 3.70404C21.2456 3.83831 21.5326 4.03475 21.7725 4.28177C22.0124 4.5288 22.2004 4.82139 22.3253 5.14227C22.4503 5.46316 22.5097 5.80583 22.5 6.15005C22.4946 6.45279 22.4267 6.75116 22.3007 7.02647C22.1746 7.30179 21.9931 7.54812 21.7675 7.75005C20.2562 9.08755 17.6337 9.4013 16.5175 9.4738C16.595 8.3663 16.9075 5.75005 18.25 4.23255ZM9.5 6.15005C9.49031 5.80583 9.5497 5.46316 9.67465 5.14227C9.79961 4.82139 9.98759 4.5288 10.2275 4.28177C10.4674 4.03475 10.7544 3.83831 11.0715 3.70404C11.3886 3.56978 11.7294 3.50041 12.0737 3.50005H12.15C12.4528 3.50539 12.7511 3.57321 13.0265 3.69925C13.3018 3.8253 13.5481 4.00686 13.75 4.23255C15.0888 5.7438 15.4013 8.3663 15.4738 9.48255C14.3625 9.41005 11.74 9.0963 10.2238 7.7588C9.99864 7.5551 9.81813 7.30701 9.69357 7.03014C9.56901 6.75327 9.50311 6.45363 9.5 6.15005ZM4.5 15V11C4.5 10.8674 4.55268 10.7403 4.64645 10.6465C4.74021 10.5527 4.86739 10.5 5 10.5H15.5V15.5H5C4.86739 15.5 4.74021 15.4474 4.64645 15.3536C4.55268 15.2598 4.5 15.1327 4.5 15ZM6.5 25V16.5H15.5V25.5H7C6.86739 25.5 6.74021 25.4474 6.64645 25.3536C6.55268 25.2598 6.5 25.1327 6.5 25ZM25.5 25C25.5 25.1327 25.4473 25.2598 25.3536 25.3536C25.2598 25.4474 25.1326 25.5 25 25.5H16.5V16.5H25.5V25ZM27.5 15C27.5 15.1327 27.4473 15.2598 27.3536 15.3536C27.2598 15.4474 27.1326 15.5 27 15.5H16.5V10.5H27C27.1326 10.5 27.2598 10.5527 27.3536 10.6465C27.4473 10.7403 27.5 10.8674 27.5 11V15Z" fill="#2F80ED" />
                        </svg>
                    </Grid>
                    <Grid style={{ textAlign: "center", justifyContent: "center" }} container item xs={8}>
                        <Hidden smUp>
                            <Typography variant={'h5'} color={'#555F7E'} style={{ width: "100%" }}>
                                Ви впевнені, що хочете придбати цей товар за бонуси?
                            </Typography>
                        </Hidden>
                        <Hidden xsDown>
                            <Typography variant={'h3'} color={'#555F7E'} style={{ width: "100%" }}>
                                Ви впевнені, що хочете придбати цей товар за бонуси?
                            </Typography>
                        </Hidden>
                    </Grid>
                    <Grid container item xs={2} alignItems="flex-start" align="right">
                        <span style={{ width: '100%' }}>
                            <IconButton className={'close'} onClick={onClose} size={'small'}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24 2.41714L21.5829 0L12 9.58286L2.41714 0L0 2.41714L9.58286 12L0 21.5829L2.41714 24L12 14.4171L21.5829 24L24 21.5829L14.4171 12L24 2.41714Z" fill="#2F80ED" />
                                </svg>
                            </IconButton>
                        </span>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent style={{
                flex: "1 1 auto",
                overflowY: "auto",
                padding: "0 32px 32px 32px"
            }}>
                <Grid container>
                    <div className={classes.root}>
                        <p className="dashboard-text">{data?.article}</p>
                        <h1>{data?.name}</h1>
                        <p className={classes.price}>{data?.price} {t('common:points_label')}</p>
                        <img src={data?.image} alt={data?.name} />
                        <button disabled={disabled} className="btn" onClick={onClick}>{t('common:yes_buy_it_label')}</button>
                    </div>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

export default PopupAddBonusItem